import BaseModel from './BaseModel'
import { ChannelFacility } from './ChannelFacility'
import { DefaultRate } from './DefaultRate'
import ParentSpotRate from './ParentSpotRate'
import Event from './Event'

/**
 * @todo Add types for API methods.
 */
export class SpotRate extends BaseModel {

  static entity = 'spot_rates'
  static primaryKey = 'ID'

  declare ID: number|string
  declare defaultRateID: number
  declare startDate: string
  declare endDate: string
  declare spotCost: number
  declare eventID: number|null
  declare eventName: string|null
  declare eventDate: string|null
  declare eventStartUtc: string|null
  declare eventStartLocal: string|null
  declare eventEndUtc: string|null
  declare eventEndLocal: string|null
  declare venueID: number|null
  declare venueName: string|null
  declare channel: string|null
  declare channelFacilityID: number|null
  declare parentSpotRateID: number|null
  declare channelFacility: ChannelFacility
  declare defaultRate: DefaultRate
  declare event: Event
  declare parentSpotRate: ParentSpotRate

  static fields() {

    return {

      // fields
      ID: this.attr(null), // should be an int (for true spot rates), or a string in the format "unified_{sr_id_1}_{sr_id_2}_..." (for virtual "unified" spot rates)
      defaultRateID: this.number(null),
      startDate: this.string(null),
      endDate: this.string(null),
      spotCost: this.number(null),
      eventID: this.number(null).nullable(),
      eventName: this.string(null).nullable(),
      eventStartUtc: this.string(null).nullable(),
      eventStartLocal: this.string(null).nullable(),
      eventEndUtc: this.string(null).nullable(),
      eventEndLocal: this.string(null).nullable(),
      venueID: this.number(null).nullable(),
      venueName: this.string(null).nullable(),
      channel: this.string(null).nullable(), // not applicable to unified SRs
      channelFacilityID: this.number(null).nullable(), // not applicable to unified SRs
      parentSpotRateID: this.number(null).nullable(),

      // relationships
      channelFacility: this.belongsTo(ChannelFacility, 'channelFacilityID'),
      defaultRate: this.belongsTo(DefaultRate, 'defaultRateID'),
      event: this.belongsTo(Event, 'eventID'),
      parentSpotRate: this.belongsTo(ParentSpotRate, 'parentSpotRateID'),

    }

  }

}
